<script>
import {
  CdrText,
  CdrPicture,
} from '@rei/cedar';
import { CdrBreakpointSm } from '@rei/cdr-tokens';

export default {
  name: 'LandingLead',
  components: {
    CdrPicture,
    CdrText,
  },
  props: {
    heroImage: {
      type: String,
      default: '',
    },
    heroAlt: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imgSourceObj: {
        mobile: {
          media: '(min-width: 800px)',
          srcset: `
            ${this.heroImage}?im=Resize,width=1600 2x,
            ${this.heroImage}?im=Resize,width=800
            `,
        },
        desktop: {
          srcset: `
            ${this.heroImage}?im=Resize,width=800 800w,
            ${this.heroImage}?im=Resize,width=700 700w,
          `,
          width: '100vw',
        },
      },
    };
  },
  computed: {
    renderLead() {
      return this.heroImage
        && this.heading
        && this.text;
    },
    smallBreakpoint() {
      return CdrBreakpointSm - 1;
    },
  },
};
</script>

<template>
  <section
    v-if="renderLead"
    id="ea_lead-component"
    class="ea-lead"
  >
    <div>
      <cdr-picture
        v-if="heroImage"
        class="ea-lead__image ea-lead__image-main"
        :sources="imgSourceObj"
        :src="heroImage"
        :alt="heroAlt"
      />
    </div>
    <div
      class="ea-lead__copy"
    >
      <div>
        <cdr-text
          tag="h1"
          class="ea-lead__heading"
        >
          {{ heading }}
        </cdr-text>
        <cdr-text
          class="ea-lead__body"
          v-html="text"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';

  .ea-lead {
    .ea-lead__image-main img {
      width: 100%;
      max-height: 400px;
      object-fit: cover;
    }

    .ea-lead__copy{
      text-align: center;

      @include cdr-container;

      max-width: 876px;
      margin-top: $cdr-space-two-x;
    }

    .ea-lead__heading {
      @include cdr-text-heading-serif-strong-800;

      margin: $cdr-space-one-and-a-half-x 0;

      @include cdr-sm-mq-up {
        @include cdr-text-heading-serif-strong-900;
      }

      @include cdr-md-mq-up {
        @include cdr-text-heading-serif-strong-1000;
      }
    }

    .ea-lead__body {
      @include cdr-text-body-400;
    }
  }
</style>
